import type { ComponentStyleConfig } from '@chakra-ui/theme';
import { Colors, TextStyles, FontWeights, Space } from '../../types';

export const FormLabel: ComponentStyleConfig = {
  baseStyle: {
    '&:is(label)': { apply: `textStyles.${TextStyles.UI_DEFAULT}` },
    fontWeight: FontWeights.MEDIUM,
    display: 'flex',
    alignItems: 'baseline',
    alignSelf: 'center',
    color: Colors.TEXT_EMPHASIS,
    flexWrap: 'wrap',
    me: Space['2XS'],
    mb: Space['2XS'],
    gap: Space['2XS'],
    _disabled: {
      opacity: 1,
    },
    legend: {
      fontWeight: FontWeights.SEMIBOLD,
      apply: `textStyles.${TextStyles.P1}`,
      color: Colors.TEXT_EMPHASIS,
      mb: Space.XS,
    },
  },
};
